export default "__VITE_ASSET__C3DgXJbJ__"